import React from 'react'

import { useQuery } from '@apollo/client'
import { cloneDeep } from 'lodash/lang'

import query from './query.graphql'

const withQuery = WrappedComponent => {
  return props => {
    const {
      parentId, // via withParams
      setParentForm, // via redux actions
      setErrorMessage, // via redux actions
      onQueryError, // via withQueryResults
      onLoggedInQueryCompleted // via withQueryResults
    } = props

    // react hooks
    const {
      loading: queryLoading,
      error: queryError,
      data: queryData
    } = useQuery(query, {
      variables: { parentId },
      onError: onQueryError,
      onCompleted: data => handleQueryCompleted(data)
    })

    const handleQueryCompleted = data => {
      if (!onLoggedInQueryCompleted(data)) {
        return
      }

      if (data && data.viewer) {
        const parent = data.viewer.parents[0]

        if (!parent) {
          setErrorMessage('The parent was not found')
          return
        }

        setParentForm(cloneDeep(parent))
      }
    }

    // GraphQL data
    const {
      viewer: account,
      seasons,
      countries,
      states,
      text
    } = queryData || {}
    const parent = account ? account.parents[0] : null
    const season = seasons ? seasons[0] : null

    return (
      <WrappedComponent
        queryLoading={queryLoading}
        queryError={queryError}
        parent={parent}
        countries={countries}
        states={states}
        text={text}
        account={account}
        season={season}
        {...props}
      />
    )
  }
}

export default withQuery
